module.exports = __webpack_public_path__ + "static/media/18_crisalide.82d68c7b.jpg";